<template>
	<!-- <f7-page class="" id="draft"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav3 bottomButton floatingButtonToolbarBlank" @click="sendAllReadyPayments">
        <f7-icon f7="sort_down_round_fill"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="createDraft">
        <f7-icon f7="edit"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav bottomButton floatingButtonToolbarBlank" @click="sendPayments" v-if="draftsSelected.length > 0">
        <i class="icon-mail_reply icon icon-float-button"></i>
      </f7-fab>
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>

    </div>
    <div class="page-content">
      <!-- TODO -->
      <!-- <f7-toolbar bottom>
        <f7-link></f7-link>
        <f7-link class="streammindBlueFont" @click="sendAllReadyPayments">Send all</f7-link>
      </f7-toolbar>
      <f7-fab class="leftfavWithToolbar orangeBackground" @click="sendPayments" v-if="draftsSelected.length > 0">
        <f7-icon f7="add"></f7-icon>
      </f7-fab> -->
      <!-- TODO -->
      <page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverSendbox" subNavTitle="Modular Loan - Draft" :menuAccess="true"></page-nav-bar>

      <div class="row form-group" :class="colorBottomButton">
        <div class="row showLargeScreenOnly rowSearchBar">
          <div class=" firstButtonMarginLeft">
            <button class="new-button milkyBlock" @click="sendAllReadyPayments">
              <f7-icon f7="sort_down_round_fill"></f7-icon>
              <span>Send completed drafts</span>
            </button>
          </div>
          <div class="">
            <button class="new-button milkyBlock rowSearchBar" @click="createDraft">
              <f7-icon f7="add"></f7-icon>
              <span>Create new draft</span>
            </button>
          </div>
          <div class="" v-if="draftsSelected.length > 0">
            <button class="new-button milkyBlock" @click="sendPayments">
              <i class="icon-mail_reply icon icon-float-sub-button"></i>
              <span>Reply</span>
            </button>
          </div>
          <div class="">
            <button class="new-button milkyBlock pull-right" @click="extractCSV(drafts)">
              <f7-icon f7="document_text"></f7-icon>
              <span>Extract CSV</span>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
      		<f7-searchbar class="search"
    			cancel-link="Cancel"
          placeholder="Search in Drafts"
    			search-list="#draft-list"
          @searchbar:search="onSearch"
          @searchbar:clear="onClear">
      		</f7-searchbar>
        </div>
      </div>
  		<div class="layoutSubtitle"/>
      <cm-draft-list :filterBy="filterBy" :drafts="drafts"></cm-draft-list>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import DraftList from './DDDraftList.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import moment from 'moment'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'draft',
  components: {
    'cm-draft-list': DraftList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      drafts: [],
      draftsSelected: [],
      filterBy: ''
    }
  },
  created () {
    let that = this
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    // this.drafts = this.$engine.drafts.get()
    this.$engine.ddDrafts.getDrafts().then(response => {
      that.status = response.status
      if (response.status === 200) {
        that.drafts = response.data.drafts
      }
    })
    .catch(error => {
      errorMessageAlert(error, that)
    })

    that.$$(document).on('taphold', '.draftTaphold', function () {
      if (that.$$(this).data('complete') === '1') {
        if (that.draftsSelected.includes(that.$$(this).data('item')) === false) {
          that.draftsSelected.push(that.$$(this).data('item'))
          that.$$(this).addClass('listItemSelected')
        } else if (that.draftsSelected.includes(that.$$(this).data('item')) === true) {
          let index = that.draftsSelected.indexOf(that.$$(this).data('item'))
          if (index > -1) {
            that.draftsSelected.splice(index, 1)
          }
          that.$$(this).removeClass('listItemSelected')
        }
      }
    })
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onClear: function () {
      this.filterBy = ''
    },
    extractCSV (drafts) {
      let firstLine = 'draftName;Status\r\n'
      let lines = ''
      for (let datas in drafts) {
        lines += drafts[datas]['draftName'] + ';'
        lines += DraftList.methods.getStatusLabel(drafts[datas]['isComplete']) + '\r\n'
      }

      let data = firstLine + lines

      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      let today = moment()
      const fileName = 'draftsModularLoan' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    createDraft () {
      this.$engine.settings.set({preChargedDraft: undefined})
      loadPage(this, {url: '/directDebit/draft/create/'})
    },
    sendPayments () {
      let that = this
      let draftValidationArray = []
      for (let i = 0; i < this.drafts.length; i++) {
        if (that.draftsSelected.includes(this.drafts[i].idDraft)) {
          draftValidationArray.push({
            'idDraft': this.drafts[i].idDraft,
            'idAccount': this.drafts[i].idAccount,
            'CreditorBankAccount': this.drafts[i].CreditorBankAccount,
            'CreditorIdentifier': this.drafts[i].CreditorIdentifier,
            'DebtorName': this.drafts[i].DebtorName,
            'DebtorBankAccount': this.drafts[i].DebtorBankAccount,
            'DebtorIdentifier': this.drafts[i].DebtorIdentifier,
            'RemittanceInformation': this.drafts[i].RemittanceInformation,
            'ImmPmtAccepted': this.drafts[i].ImmPmtAccepted,
            'PymtNtr': this.drafts[i].PymtNtr,
            'RequestedExecutionDate': this.drafts[i].RequestedExecutionDate,
            'Amount': this.drafts[i].Amount,
            'ModificationAccepted': this.drafts[i].ModificationAccepted,
            'AttachmentId': this.drafts[i].AttachmentId,
            'AttachmentName': this.drafts[i].AttachmentName,
            'AttachmentReference': this.drafts[i].AttachmentReference
          })
        }
      }
      let requestLoad = {
        'drafts': draftValidationArray
      }
      that.$engine.dpDrafts.validateDraft(requestLoad, this.draftsSelected)
      .then(response => {
        if (response.status === 200) {
          that.$engine.dpDrafts.deleteById(that.draftsSelected)
          that.$f7.modal({
            title: 'Modular loans sent',
            text: '<span class="preloader"></span>'
          })
          that.draftsSelected = []
          setTimeout(function () {
            that.$f7.closeModal()
            that.Dom7('.draftTaphold').removeClass('listItemSelected')
            // that.draftsSelected = []
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    sendAllReadyPayments () {
      let that = this
      let draftValidationArray = []
      let draftIdArray = []
      for (let i = 0; i < that.drafts.length; i++) {
        if (this.drafts[i].isComplete === '1') {
          draftValidationArray.push({
            'idDraft': this.drafts[i].idDraft,
            'idAccount': this.drafts[i].idAccount,
            'CreditorBankAccount': this.drafts[i].CreditorBankAccount,
            'CreditorIdentifier': this.drafts[i].CreditorIdentifier,
            'DebtorName': this.drafts[i].DebtorName,
            'DebtorBankAccount': this.drafts[i].DebtorBankAccount,
            'DebtorIdentifier': this.drafts[i].DebtorIdentifier,
            'RemittanceInformation': this.drafts[i].RemittanceInformation,
            'ImmPmtAccepted': this.drafts[i].ImmPmtAccepted,
            'PymtNtr': this.drafts[i].PymtNtr,
            'RequestedExecutionDate': this.drafts[i].RequestedExecutionDate,
            'Amount': this.drafts[i].Amount,
            'ModificationAccepted': this.drafts[i].ModificationAccepted,
            'AttachmentId': this.drafts[i].AttachmentId,
            'AttachmentName': this.drafts[i].AttachmentName,
            'AttachmentReference': this.drafts[i].AttachmentReference
          })
          draftIdArray.push(this.drafts[i].idDraft)
        }
      }
      if (draftValidationArray.length > 0) {
        let requestLoad = {
          'drafts': draftValidationArray
        }
        that.$engine.dpDrafts.validateDraft(requestLoad, draftIdArray)
        .then(response => {
          if (response.status === 200) {
            // that.$engine.dpDrafts.deleteById(draftIdArray)
            that.$f7.modal({
              title: 'Modular loans sent',
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.Dom7('.draftTaphold').removeClass('listItemSelected')
              loadPage(that, {url: '/directDebit/sendbox/'})
              // that.draftsSelected = []
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$f7.alert('', 'No ready draft', function () {
          return
        })
      }
    }
  }
}
</script>
<style>
</style>
